module.exports = __webpack_public_path__ + "static/media/md-videocam.deb3e4aa.svg";